/**
 * 案件名の変更（リネーム）の契約（path・リクエスト / レスポンス型・許可根拠）。
 *
 * 案件仕様書の「リネーム」ボタン（GAS `upsertProjectName`）を cortex へ移したもの。
 * PI Lab の案件詳細画面と mcp-project-management が**同じ path と型を引く**ために、
 * サービス間契約のこのパッケージに置く（`apps/` 間の直接 import は不可）。
 *
 * 文字数の上限などの判定値はここに置かない。上限は product-api だけが持ち、画面と MCP は
 * API が返したメッセージをそのまま見せる（入口に値を写すと、API 側で変えたときに黙ってずれる）。
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 案件名の変更で product-api / Web / MCP が共有する path と型
 * @graph-connects none
 */
/**
 * 案件名の変更 path（PATCH）。対象は母票（親チケット）。
 * @graph-connects none
 */
export function projectNamePath(issueKey) {
    return `/projects/${encodeURIComponent(issueKey)}/name`;
}
/** 許可根拠の日本語表示名（MCP の出力・403 の説明文で使う）。 @graph-connects none */
export const PROJECT_RENAME_OWNERSHIP_LABELS = {
    pl: 'PL',
    'main-worker': '主担当',
    'dev-leader': '開発リーダー',
};
/** 全値（レスポンス schema の enum に使う）。 @graph-connects none */
export const PROJECT_RENAME_SLACK_STATUSES = [
    'renamed',
    'unchanged',
    'no_channel',
    'failed',
];
//# sourceMappingURL=project-rename.js.map